<!--
/*******************************************************************************
*@ 컴포넌트명   : Popup.vue
*@ 컴포넌트설명 : popup 공통컴포넌트 - 전체화면
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div v-if="thisOpened" class="popup" :class="{ 'all-scroll': allScroll, visible: visible  }">
    <div class="inner" ref="captureBody">
      <div
        v-if="useHeader"
        class="popup-header"
        :class="{ hasborder: useTopBorder,
          'header-align-left': titalignLeft, }"
      >
        <!-- 타이틀 -->
        <div class="popup-title">
          <h4>{{ $t(title) }}</h4>
          <button class="btn-close" data-html2canvas-ignore="true" @click="cancelClick()"></button>
        </div>
        <!--// 타이틀 -->
        <!-- 서브 타이틀 -->
        <div class="description">
          <slot name="subtitle">
            {{ subtitle }}
            <br v-if="subtitle2" />
          </slot>
          <slot name="subtitle2">
            {{ subtitle2 }}
            <br v-if="subtitle3" />
          </slot>
          <slot name="subtitle3">{{ subtitle3 }}</slot>
        </div>
        <!--// 서브 타이틀 -->
      </div>
      <div
        v-if="useBody"
        class="popup-body"
        :class="[{ paddingbtm: !useFooter }, { 'no-scroll-y': noBodyScroll }]"
      >
        <slot name="content"></slot>
        <save-and-share
          v-if="saveAndShare"
          data-html2canvas-ignore="true"
          popup.vue
          ref="saveNShare"
        ></save-and-share>
      </div>
      <footer
        data-html2canvas-ignore="true"
        v-if="useFooter"
        class="popup-footer"
        :class="{ hasborder: useBottomBorder, 'btn-padding': btnAreaPadding  }"
      >
        <div class="btn-area--bottom">
          <slot name="footer">
            <button
              class="btn bottom negative"
              v-if="noNegativeButton"
              @click="cancelClick"
            >{{$t(cancel)}}</button>
            <button class="btn bottom positive" @click="confirmClick">{{$t(confirm)}}</button>
          </slot>
        </div>
      </footer>
    </div>
  </div>
</template>
<style type="scss" scoped></style>
<script>
import { mapFields } from "vuex-map-fields";
import { BaseComponent } from "@/components/base-component";
import SaveAndShare from "@/components/page/accounts/SaveAndShare";
export default {
  name: "Popup",
  components: { SaveAndShare },
  extends: BaseComponent,
  props: {
    opened: { type: Boolean, default: true },
    close: { type: Boolean, default: false },
    useHeader: { type: [Boolean], default: true },
    useBody: { type: [Boolean], default: true },
    useFooter: { type: [Boolean], default: false },
    title: { type: String, default: undefined, required: false },
    subtitle: { type: String, default: undefined, required: false },
    subtitle2: { type: String, default: undefined, required: false },
    subtitle3: { type: String, default: undefined, required: false },
    cancel: { type: String, default: "MCOM-0000033", required: false },
    confirm: { type: String, default: "MCOM-0000034", required: false },
    useTopBorder: { type: Boolean, default: false, required: false },
    useBottomBorder: { type: Boolean, default: false, required: false },
    btnAreaPadding: { type: [Boolean], default: true },
    // 부정 버튼 사용 여부
    noNegativeButton: { type: Boolean, default: false },
    titalignLeft: { type: [Boolean], default: false },
    noBodyScroll: { type: Boolean, default: false, required: false },
    allScroll: { type: Boolean, default: false, required: false },
    //popup overflow 해제
    visible: { type: Boolean, default: false },
    //저장, 공유 버튼
    saveAndShare: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
  created() {
    this.$EventBus.$on("popupClose", () => {
      this.cancelClick();
    });
  },
  computed: {
    ...mapFields(["popupOpen"]),
    thisOpened: {
      get() {
        if (this.opened) {
          this.setPopupOpen();
        }
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    setPopupOpen() {
      this.popupOpen = true;
    },
    done() {
      this.popupOpen = false;
      this.$emit("update:opened", false);
    },
    confirmClick() {
      this.$emit("confirm");
      this.done();
    },
    cancelClick() {
      this.$emit("cancel");
      this.done();
    },
  },
};
</script>
